
  function autoLogin() {
    const textEl = document.getElementById('kwik-pass-text');
    const accountEl = document.getElementById('kp-account');
    if (textEl) textEl.textContent = 'My Account';
    if (accountEl) {
      accountEl.classList.remove('kwik-pass-login');
      accountEl.classList.add('kwik-pass-account');
      const acct = document.getElementsByClassName('kwik-pass-account')[0];
      if (acct) {
        acct.addEventListener('click', function () {
          if (typeof handleKpAndShopifyLogin === 'function') {
            handleKpAndShopifyLogin('/account');
          }
        });
      }
    }
  }

  window.addEventListener('user-loggedin', function (event) {
    const token = event && event.detail ? event.detail.token : undefined;
    if (token) {
      autoLogin();
    }
  });

  const storedToken = localStorage.getItem('KWIKSESSIONTOKEN');
  if (storedToken) {
    autoLogin();
  }

  const accItems = document.getElementsByClassName('demo');
  for (let j = 0; j < accItems.length; j++) {
    accItems[j].addEventListener('click', function () {
      this.classList.toggle('active');
      const panel = this.nextElementSibling;
      if (panel) {
        panel.style.display = panel.style.display === 'inherit' ? 'none' : 'contents';
      }
    });
  }

  const caret = document.querySelector('.icon-caret');
  if (caret) {
    caret.addEventListener('click', () => {
      caret.innerHTML = '<path d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path>';
    });
  }

  const wrapperEl = document.querySelector('.header-wrapper');
  const placeholdersAttr = wrapperEl ? wrapperEl.getAttribute('data-dynamic-placeholders') : '';
  let placeholderWords = [];
  if (placeholdersAttr && placeholdersAttr.trim().length > 0) {
    placeholderWords = placeholdersAttr.split(',').map(s => s.trim().replace(/^['"]|['"]$/g, ''));
  }
  if (placeholderWords.length > 0) {
    const placeholderPrefix = 'Search for ';
    let wordIndex = 0;
    let charPosition = 0;
    let deleting = false;
    let typingTimer;

    const searchInputs = [
      document.querySelector('.header-search-bar-mobile-container .search__input.field__input'),
      document.querySelector('.header-search-bar-desktop-container .search__input.field__input')
    ];

    const updatePlaceholders = (text) => {
      searchInputs.forEach(input => {
        if (input && document.activeElement !== input) {
          input.placeholder = placeholderPrefix + text;
        }
      });
    };

    const typeAnimation = () => {
      const currentWord = placeholderWords[wordIndex] || '';
      const displayedText = currentWord.substring(0, charPosition);
      updatePlaceholders(displayedText);
      if (!deleting && charPosition < currentWord.length) {
        charPosition++;
        typingTimer = setTimeout(typeAnimation, 100);
      } else if (deleting && charPosition > 0) {
        charPosition--;
        typingTimer = setTimeout(typeAnimation, 80);
      } else {
        if (!deleting) {
          deleting = true;
          typingTimer = setTimeout(typeAnimation, 1000);
        } else {
          deleting = false;
          wordIndex = (wordIndex + 1) % placeholderWords.length;
          typingTimer = setTimeout(typeAnimation, 300);
        }
      }
    };

    searchInputs.forEach(input => {
      if (!input) return;
      input.addEventListener('focus', () => {
        clearTimeout(typingTimer);
      });
      input.addEventListener('blur', () => {
        typingTimer = setTimeout(typeAnimation, 300);
      });
    });

    typeAnimation();
  }

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      requestAnimationFrame(this.reveal.bind(this));
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      const observer = new IntersectionObserver((entries, ob) => {
        this.headerBounds = entries[0].intersectionRect;
        ob.disconnect();
      });
      if (this.header) observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.preventReveal) {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);
        // requestAnimationFrame(this.hide.bind(this));
      } else {
        if (scrollTop <= 1) {
          // requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop > 10) {
          requestAnimationFrame(this.reveal.bind(this));
        } else if (scrollTop <= this.headerBounds.top) {
          // requestAnimationFrame(this.reset.bind(this));
        }
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (!this.header) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (!this.header) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (!this.header) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || (this.header ? this.header.querySelectorAll('details-disclosure') : []);
      if (this.disclosures && this.disclosures.forEach) {
        this.disclosures.forEach(disclosure => disclosure.close());
      }
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || (this.header ? this.header.querySelector('details-modal') : null);
      if (this.searchModal && this.searchModal.close) {
        this.searchModal.close(false);
      }
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  if (window.innerWidth < 990) {
    const saleTicker = document.querySelector('.ticker_wrapper');
    const headerDrawer = document.querySelector('#menu-drawer');
    const closeIcon = document.querySelector('.drawer-close__icon svg');

    setTimeout(() => {
      const saleTickerBottom = saleTicker ? saleTicker.getBoundingClientRect().bottom : null;
      if (saleTickerBottom !== null && saleTickerBottom !== undefined) {
        if (saleTickerBottom <= 0) {
          if (headerDrawer) headerDrawer.style.top = -19 + 'px';
          if (closeIcon) closeIcon.style.top = 6 + 'px';
        } else {
          if (headerDrawer) headerDrawer.style.top = '-' + saleTickerBottom + 'px';
          if (closeIcon) closeIcon.style.top = '-' + (parseInt(saleTickerBottom) - 22) + 'px';
        }
      }
    }, 1000);

    document.addEventListener('scroll', () => {
      const saleTickerBottom = saleTicker ? saleTicker.getBoundingClientRect().bottom : null;
      if (saleTickerBottom !== null && saleTickerBottom !== undefined) {
        if (saleTickerBottom <= 0) {
          if (headerDrawer) headerDrawer.style.top = -19 + 'px';
          if (closeIcon) closeIcon.style.top = 6 + 'px';
        } else {
          if (headerDrawer) headerDrawer.style.top = '-' + saleTickerBottom + 'px';
          if (closeIcon) closeIcon.style.top = '-' + (parseInt(saleTickerBottom) - 22) + 'px';
        }
      }
    });
  }



